import { ZError } from '../types/zod-schemas';

/**
 * Extract a human-readable message from an unknown thrown value. Handles
 * Error instances and PostgREST/Supabase error objects ({ message, code }).
 */
export const getErrorMessage = (error: unknown, fallback: string): string => {
  if (error instanceof Error && error.message) return error.message;
  const parsed = ZError.safeParse(error);
  if (parsed.success && parsed.data.message) return parsed.data.message;
  return fallback;
};
